/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kpi_Overflow_LocationsInputs */

const en_us2_kpi_overflow_locations = /** @type {(inputs: Kpi_Overflow_LocationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Number of overflow locations`)
};

const en_gb2_kpi_overflow_locations = /** @type {(inputs: Kpi_Overflow_LocationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Number of spill locations`)
};

/**
* | output |
* | --- |
* | "Number of overflow locations" |
*
* @param {Kpi_Overflow_LocationsInputs} inputs
* @param {{ locale?: "en-US" | "en-GB" }} options
* @returns {LocalizedString}
*/
export const kpi_overflow_locations = /** @type {((inputs?: Kpi_Overflow_LocationsInputs, options?: { locale?: "en-US" | "en-GB" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kpi_Overflow_LocationsInputs, { locale?: "en-US" | "en-GB" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en-GB") return en_gb2_kpi_overflow_locations(inputs)
	return en_us2_kpi_overflow_locations(inputs)
});